import { VIP_TYPE } from "@/constants/vip"
import { VOICE_AUTH_TYPE } from "@/constants/voice";

type VOICE_STATUS = {
    owned: boolean; // 是否已拥有声音
    isPaidVoice: boolean; // 是否是付费声音
    isMemberVoice: boolean; // 是否是会员声音
}

// 获取声音状态
function getVoiceStatus({
    vipInfo, voiceInfo,
    purchased = []
}) {
    const vipType = vipInfo.type;
    const vipAuth = voiceInfo.vipAuth
    // 拥有付费声音
    const paidOwned = vipAuth === VOICE_AUTH_TYPE.PAID && voiceInfo.usable
    // 拥有私人声音(目前包含问问实验室和声音克隆)
    const privateOwned = vipAuth === VOICE_AUTH_TYPE.PRIVATE 
    
    // 拥有超级会员声音
    const vipOwned = vipAuth === VOICE_AUTH_TYPE.VIP && (vipType === VIP_TYPE.VIP || vipType === VIP_TYPE.SVIP)
    // 拥有会员声音
    const svipOwned = vipAuth === VOICE_AUTH_TYPE.SVIP && vipType === VIP_TYPE.SVIP
    // 直接购买获得声音
    const purchaseOwned = !!purchased.find(voice => voice.speaker === voiceInfo.speaker)
    return {
        owned: paidOwned || vipOwned || svipOwned || purchaseOwned||privateOwned,
        isPaidVoice: vipAuth === VOICE_AUTH_TYPE.PAID,
        isMemberVoice: vipAuth === VOICE_AUTH_TYPE.VIP || vipAuth === VOICE_AUTH_TYPE.SVIP,
    }
}

export default {
    getCurrentPageName(state) {
        return state.currentPageName;
    },

    getVoiceStatus: (state) => (speaker): VOICE_STATUS => {
        return getVoiceStatus({
            vipInfo: state.vipInfo,
            voiceInfo: speaker,
            purchased: state.purchasedSpeakerList
        })
    }
}